import { Button, FlexGrid, stl, TooltipWrapper } from '@algolia/satellite'
import { isEmpty } from 'lodash'
import type { FunctionComponent } from 'react'
import { LogOut, Settings } from 'react-feather'
import { Link, useNavigate } from 'react-router-dom'

import algolia from '../../../assets/images/algolia-small.svg'
import { clearToken } from '../../../utils/tokenManager'
import { useAuth } from '../../AuthContext'
import { Breadcrumbs } from '../breadcrumbs'

import './header.css'

export type HeaderSteps = {
    currentStep: number
    nbSteps: number
}

type HeaderProps = {
    title?: string
    steps?: HeaderSteps
}

export const Header: FunctionComponent<HeaderProps> = (
    props: HeaderProps
): any => {
    const { title, steps } = props
    const { platform, appexJwt } = useAuth()
    const navigate = useNavigate()

    return (
        <div className="header-bar stl-w-full stl-p-5 stl-text-left stl-bg-white stl-flex stl-items-center">
            <FlexGrid spacing="sm" alignment="center">
                <Link to={`/`}>
                    <img
                        src={algolia}
                        className={stl`display-heading mr-4 w-6`}
                    />
                </Link>
                <Breadcrumbs />
                <h1 className={stl`display-heading  stl-text-grey-900`}>
                    {title}
                </h1>
            </FlexGrid>
            <div className={stl`flex items-center justify-between`}>
                {steps !== undefined && (
                    <h2 className={stl`display-heading stl-text-grey-900`}>
                        {`Step ${steps.currentStep} of ${steps.nbSteps}`}
                    </h2>
                )}
                {!isEmpty(appexJwt) &&
                    !isEmpty(platform?.integration_id) &&
                    platform?.integrations?.sources.length !== 0 && (
                        <TooltipWrapper
                            delay={500}
                            content={`Application Settings`}
                        >
                            <span className="header-settings">
                                <Settings
                                    onClick={(): void => {
                                        navigate(`/settings`)
                                    }}
                                />
                            </span>
                        </TooltipWrapper>
                    )}
                {platform === null && (
                    <div className={stl`px-2`}>
                        <Button
                            endIcon={LogOut}
                            variant="subtle"
                            onClick={(): void => {
                                clearToken()
                                location.href = `/api/v1/logout`
                            }}
                        >
                            Sign out
                        </Button>
                    </div>
                )}
            </div>
        </div>
    )
}
